<template>
  <div>
    <el-drawer :modal="false"  title="FINTSCORE Report" :visible.sync="showDrawer" class="drawer-fintscore-report" size="45%">
      <b-container>
        <b-row class="mt-3">
          <b-col cols="12">
            <div class="mb-3">
              <el-button class="bg-primary text-white my-0" :loading="is_loading_purchase"
                @click="openPurchaseReportDrawer" v-if="activeCustomer && !activeCustomer.cjp_id"><b-icon icon="cart-fill"></b-icon>
                Purchase CTOS - only RM{{ discount_fintscore_price }}
              </el-button>
            </div>
						<h3>LMS Credit Report History</h3>
            <div class="card-table rounded-bottom mb-4">
              <el-table :data="tableData" style="width: 100%">
                <el-table-column prop="credit_report_id" label="ID">
                  <template v-slot="{ row }">
                    {{ row.credit_report_id }}
                  </template>
                </el-table-column>
                <el-table-column prop="credit_report_request_datetime" label="Requested Date" min-width="160">
                  <template v-slot="{ row }">
                    <!-- {{ row.credit_report_request_datetime | dateTimeFormatString }} -->
                    {{ row.credit_report_request_datetime }}
                  </template>
                </el-table-column>
                <el-table-column prop="angkasa" label="Angkasa (SPGA)" min-width="150" class-name="text-center">
                  <template v-slot="{ row }">
                    <i class="fa fa-check-circle text-success fa-lg" v-if="row.credit_report_angkasa"></i>
                  </template>
                </el-table-column>
                <el-table-column prop="ccris_sum_current_installment" label="FINTSCORE Report" min-width="170">
                  <template v-slot="{ row }">
                    <a href="javascript:void(0)" @click="$refs.preview_modal.preview(row.credit_report_fintscore_unsigned_url)"
                      class="font-weight-bold" v-if="row.credit_report_fintscore_unsigned_url !== ''">Download Report</a>
                    <span v-else>-</span>
                  </template>
                </el-table-column>
                <el-table-column prop="ccris_sum_current_installment" label="Consent Form" min-width="170">
                  <template v-slot="{ row }">
                    <a href="javascript:void(0)"
                      @click="$refs.preview_modal.preview(row.credit_report_consent_unsigned_url)"
                      class="font-weight-bold" v-if="row.credit_report_consent_unsigned_url !== ''">Download Form</a>
                    <span v-else>-</span>
                  </template>
                </el-table-column>
              </el-table>
            </div>

						<h3>SAS Credit Report History</h3>
						<div class="card-table rounded-bottom">
              <el-table :data="tableDataSas" style="width: 100%">
                <el-table-column prop="credit_report_id" label="ID">
                  <template v-slot="{ row }">
                    {{ row.credit_report_id }}
                  </template>
                </el-table-column>
                <el-table-column prop="credit_report_request_datetime" label="Requested Date" min-width="160">
                  <template v-slot="{ row }">
                    <!-- {{ row.credit_report_request_datetime | dateTimeFormatString }} -->
                    {{ row.credit_report_request_datetime }}
                  </template>
                </el-table-column>
                <el-table-column prop="angkasa" label="Angkasa (SPGA)" min-width="150" class-name="text-center">
                  <template v-slot="{ row }">
                    <i class="fa fa-check-circle text-success fa-lg" v-if="row.credit_report_angkasa"></i>
                  </template>
                </el-table-column>
                <el-table-column prop="ccris_sum_current_installment" label="FINTSCORE Report" min-width="170">
                  <template v-slot="{ row }">
                    <a href="javascript:void(0)" @click="$refs.preview_modal.preview(row.credit_report_fintscore_unsigned_url)"
                      class="font-weight-bold" v-if="row.credit_report_fintscore_unsigned_url !== ''">Download Report</a>
                    <span v-else>-</span>
                  </template>
                </el-table-column>
                <el-table-column prop="ccris_sum_current_installment" label="Consent Form" min-width="170">
                  <template v-slot="{ row }">
                    <a href="javascript:void(0)"
                      @click="$refs.preview_modal.preview(row.credit_report_consent_unsigned_url)"
                      class="font-weight-bold" v-if="row.credit_report_consent_unsigned_url !== ''">Download Form</a>
                    <span v-else>-</span>
                  </template>
                </el-table-column>
              </el-table>
            </div>
          </b-col>
        </b-row>
      </b-container>
    </el-drawer>
    <PreviewModal ref="preview_modal"></PreviewModal>
  </div>
</template>
<script>
import { Drawer, Button, Table, TableColumn } from 'element-ui';
import { axios, services, getHeader } from '@/assets/js/httpImports.js';
import { mapState, mapActions } from 'pinia'
import { useCustomerStore } from '@/stores/customerStore'
import { useFintscoreStore } from '@/stores/fintscoreStore'
import { useCreditReportStore } from '@/stores/creditReportStore'
import PreviewModal from '@/components/Modal/PreviewModal'
import { applicationCode } from '@/assets/js/config';

export default {
  components: {
    [Drawer.name]: Drawer,
    [Button.name]: Button,
    [Table.name]: Table,
    [TableColumn.name]: TableColumn,
    PreviewModal
  },
  data() {
    return {
      showDrawer: false,
      is_loading_purchase: false,
      is_loading: false,
      is_loading_sas: false,
      tableData: [],
      tableDataSas: [],
      app_code: applicationCode,
    }
  },
  created() {
  },
  computed: {
    ...mapState(useCustomerStore, ['activeCustomer']),
    ...mapState(useFintscoreStore, ['fintscore_reports', 'discount_fintscore_price']),
    ...mapState(useCreditReportStore, ['getCreditReports']),
  },
  // watch: {
  //   fintscore_reports(newVal) {
  //     const items = []
  //     this.tableData.forEach((item) => {
  //       newVal.forEach((f_item) => {
  //         if (item.credit_report_id == f_item.fin_credit_report_id) {
  //           items.push({
  //             ...item,
  //             fintscore_url: f_item.credit_report_pdf_unsigned_url
  //           })
  //         }
  //       })
  //     })
  //     this.tableData = items
  //   }
  // },
  methods: {
    openPurchaseReportDrawer() {
      this.showDrawer = false
      this.$emit('open-purchase-report');
    },
    openDrawer() {
			this.showDrawer = !this.showDrawer;
			this.getCreditReportHistory()
    },
    getCreditReportHistory() {
			this.is_loading = true;
			this.is_loading_sas = true;
			console.log(this.activeCustomer);
			let params = {
				is_full_content:false,
				pagination:{
					page: 0,
					limit: 50,
					order:{
						credit_report_id:'DESC'
					}
				},
				search:{
					credit_report_cust_id: this.activeCustomer?.im2u_id,
					credit_report_status: 'completed',
					credit_report_application_code: this.app_code
				}
			}

			this.getCreditReports(params).then(res => {
				this.tableData = _gHlp.getValue(res,'data',[]);
				this.is_loading = false
			}).catch(err=>{
				_gHlp.removeLoading('fetch_loan_type')
				this.is_loading = false
			});

			params.search.credit_report_cust_id = this.activeCustomer?.sas_im2u_id
			params.search.credit_report_application_code = 'sas_v2'
			this.getCreditReports(params).then(res => {
				this.tableDataSas = _gHlp.getValue(res,'data',[]);
				this.is_loading_sas = false
			}).catch(err=>{
				this.is_loading_sas = false
			});

    },
  }
}
</script>